export default __webpack_public_path__ + "static/media/partner1.c236700c.jpg";